<template>
  <div class="wrap">
    <v-checkbox
      v-model="dataValue"
      class="ui-checkbox"
      :label="label"
      :disabled="disabled"
      color="primary"
      @change="change"
    >
      <template #label>
        {{ label }}
        <span v-if="required" style="color: red; margin-left: 4px;">*</span>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
export default {
  name: 'UICheckbox',

  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: null,
    },
    errorMessages: {
      type: Array,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Введите значение',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: '',
    },
    persistentHint: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({ dataValue: null }),

  methods: {
    change(val) {
      this.$emit('change', val)
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dataValue = val
      },
    },
  },
}
</script>

<style lang="css" scoped>

.wrap {
  display: flex;
}

</style>
